module.exports = __webpack_public_path__ + "img/3.fca997a2.jpg";